/**
 * États d'écran licence — session Cloud navigateur uniquement.
 * Affichés après connexion, en attendant / après GET /v1/auth/me.
 * Ne remplace pas l'écran de login.
 */

const GATE_ID = 'cloud-licence-gate';

function renderGate(root: HTMLElement, body: string): void {
  root.className = '';
  root.innerHTML = `
    <div class="login-page" id="${GATE_ID}">
      <div class="login-card">
        ${body}
      </div>
    </div>`;
}

/** Lecture seule sans module : droits /me pas encore livrés. */
export function showCloudLicenceLoading(root: HTMLElement): void {
  renderGate(
    root,
    `<p role="status" aria-live="polite" style="text-align:center;color:var(--gris);margin:0;">
      Chargement de votre licence…
    </p>`,
  );
}

/** Après chargement /me : toujours aucun droit module. */
export function showCloudLicenceMissing(root: HTMLElement): void {
  renderGate(
    root,
    `<h2 style="margin-top:0;color:var(--marine);">Licence introuvable</h2>
     <p role="alert" style="color:var(--gris);margin:0;">
       Licence introuvable — contactez Nexxus
     </p>
     <button type="button" class="btn btn-primary" id="cloud-licence-retry"
       style="width:100%;margin-top:16px;justify-content:center;">
       Réessayer
     </button>`,
  );
  const retry = root.querySelector<HTMLButtonElement>('#cloud-licence-retry');
  retry?.addEventListener('click', () => {
    location.reload();
  });
  retry?.focus();
}

/** Retire le panneau porte licence s'il est affiché. */
export function clearCloudLicenceGate(root: HTMLElement): void {
  const gate = root.querySelector(`#${GATE_ID}`);
  if (!gate) return;
  if (gate.parentElement === root && root.children.length === 1) {
    root.innerHTML = '';
    root.className = '';
    return;
  }
  gate.remove();
}
